/**
 * Store some variables that we want to access
 * here and there
 */

import {InjectionToken} from '@angular/core'

/**
 * The routes are good to be consistent with.
 */
export const LOGIN_PATH = 'login'
export const ADMIN_HOME_PATH = 'admin'
export const WINDOW = new InjectionToken<Window>('window')
